<template>
    <div class="data-count">
        <div ref="pie" class="data-count--pie" v-auto-size></div>
    </div>
</template>
<script>
import * as largeScreenAPI from '@/api/large-screen'
import { getRelativelySize } from '@/utils/size'
import { chartFormat, handleData } from '@/utils/index'

const colorList = [
    ['#00FFBE', 'rgba(0, 255, 190, 0.2)'],
    ['#FFDD3C', 'rgba(255, 221, 60, 0.2)'],
    ['#81B2FF', 'rgba(129, 178, 255, 0.2)'],
    ['#FFAA00', 'rgba(255, 170, 0, 0.2)']
]
const nameList = ['作业面积', '合作社数量', '农机数量', '农机手数量']
const unitList = ['亩', '个', '台', '个']

export default {
    data() {
        return {
            pieInstance: null
        }
    },
    destroyed() {
        if (this.pieInstance) this.pieInstance.dispose()
    },
    mounted() {
        if (this.pieInstance) this.pieInstance.dispose()
        this.init()
    },
    methods: {
        init() {
            this.pieInstance = echarts.init(this.$refs['pie'])
            this.setOption()
        },
        async setOption() {
            const { getOption } = this

            const currScreenType = JSON.parse(
                sessionStorage.getItem('currScreenType')
            )
            const response = await largeScreenAPI.getDataCount(
                currScreenType.locId
            )
            if (response.data.length) {
                const data = handleData(response.data)
                let resultValue = 0

                // 单位转换，6 位以下为亩，6 位以上 9 位以下为万亩，9位以上 16 位以下为亿亩，16位以上显示无数据
                data.forEach((item, index) => {
                    item.color = colorList[index]
                    item.name = nameList[index]

                    if (Number(item.value) < 10000) {
                        resultValue =
                            Math.floor(parseFloat(Number(item.value)) * 100) /
                            100

                        item.value = resultValue
                        item.unit = unitList[index]
                    } else if (
                        Number(item.value) >= 10000 &&
                        Number(item.value) < 100000000
                    ) {
                        resultValue =
                            Math.floor(
                                parseFloat(Number(item.value) / 10000) * 100
                            ) / 100
                        item.value = resultValue
                        item.unit = `万${unitList[index]}`
                    } else if (
                        Number(item.value) >= 100000000 &&
                        Number(item.value) < 1000000000000
                    ) {
                        resultValue =
                            Math.floor(
                                parseFloat(Number(item.value) / 100000000) * 100
                            ) / 100
                        item.value = resultValue
                        item.unit = `亿${unitList[index]}`
                    } else if (
                        Number(item.value) >= 1000000000000 &&
                        Number(item.value) < 1000000000000000
                    ) {
                        resultValue =
                            Math.floor(
                                parseFloat(Number(item.value) / 1000000000000) *
                                    100
                            ) / 100
                        item.value = resultValue
                        item.unit = `万亿${unitList[index]}`
                    } else {
                        item.value = '无数据'
                        item.unit = '无数据'
                    }
                })
                const { valueAxis, series, colors, units } = chartFormat(data)
                this.pieInstance.setOption(
                    getOption({ valueAxis, series, colors, units })
                )
            }
        },
        getOption(data) {
            const { valueAxis, series, colors, units } = data

            const options = {
                title: valueAxis.map((name, index) => {
                    return {
                        text: name,
                        left: index * 24 + 13.2 + '%',
                        top: '71.5%',
                        textAlign: 'center',
                        textStyle: {
                            fontWeight: 'normal',
                            fontSize: getRelativelySize(18),
                            color: '#fff',
                            textAlign: 'center'
                        }
                    }
                }),
                series: series.map((value, index) => {
                    return {
                        type: 'pie',
                        clockWise: false,
                        radius: [getRelativelySize(58), getRelativelySize(68)],
                        itemStyle: {
                            normal: {
                                color: colors[index][0],
                                shadowColor: colors[index][0],
                                shadowBlur: 0,
                                label: {
                                    show: false
                                },
                                labelLine: {
                                    show: false
                                }
                            }
                        },
                        hoverAnimation: false,
                        center: [index * 24 + 14.1 + '%', '40%'],
                        data: [
                            {
                                value: 80,
                                label: {
                                    normal: {
                                        formatter: [
                                            `{a|${value}}`,
                                            `{b|(${units[index]})}`
                                        ].join('\n'),
                                        rich: {
                                            a: {
                                                padding: [
                                                    0,
                                                    0,
                                                    getRelativelySize(30),
                                                    0
                                                ],
                                                fontSize: getRelativelySize(26),
                                                fontWeight: 'bold'
                                            },
                                            b: {
                                                height: getRelativelySize(31),
                                                fontSize: getRelativelySize(18),
                                                color: '#A3A3A3'
                                            }
                                        },
                                        position: 'center',
                                        show: true,
                                        textStyle: {
                                            fontWeight: 'bold',
                                            color: colors[index][0]
                                        }
                                    }
                                }
                            },
                            {
                                value: 20,
                                itemStyle: {
                                    normal: {
                                        color: colors[index][1]
                                    },
                                    emphasis: {
                                        color: colors[index][1]
                                    }
                                }
                            }
                        ]
                    }
                })
            }

            return options
        }
    }
}
</script>
<style lang="scss" scoped>
.data-count {
    display: flex;
    color: #fff;
    width: 100%;
    height: 100%;
    &--pie {
        width: 100%;
        height: 100%;
    }
}
</style>
